import { Box, Typography, Chip, IconButton, useTheme, alpha } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const statusColor = (value, theme) => {
  const v = String(value || "").toLowerCase();
  if (v === "executed" || v === "success" || v === "complete") return theme.palette.success.main;
  if (v === "cancelled" || v === "rejected" || v === "error") return theme.palette.error.main;
  return theme.palette.text.secondary;
};

/** One order-history row as a card, with the same log button the grid cell has. */
export const OrderHistoryCard = ({ row, onViewLog }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const hasLog = Array.isArray(row.orderLog) && row.orderLog.length > 0;
  const color = statusColor(row.orderStatus, theme);

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 1,
        border: `1px solid ${alpha(primary, 0.14)}`,
        borderLeft: `3px solid ${alpha(color, 0.85)}`,
        bgcolor: theme.palette.background.paper,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap title={row.symbol} sx={{ fontWeight: 800, fontSize: "0.82rem" }}>
          {row.symbol}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.4, flexWrap: "wrap" }}>
          <Chip
            size="small"
            label={row.orderPlaced ? "Placed" : "Not placed"}
            variant="outlined"
            sx={{ height: 19, fontSize: "0.63rem", fontWeight: 700 }}
          />
          <Typography sx={{ fontSize: "0.72rem", fontWeight: 800, color }}>
            {row.orderStatus || "—"}
          </Typography>
        </Box>
      </Box>
      <IconButton
        size="small"
        onClick={() => hasLog && onViewLog(row)}
        disabled={!hasLog}
        aria-label={`View order log for ${row.symbol}`}
        sx={{ color: hasLog ? "primary.main" : "action.disabled", flexShrink: 0 }}
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default OrderHistoryCard;
